import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MWidgetsModule } from '@mining/ui/widgets';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { MTreeDirectoryComponent } from './tree-directory.component';
import { MFilterTreeNodesPipe } from './tree-directory.pipe';
@NgModule({
  declarations: [MTreeDirectoryComponent, MFilterTreeNodesPipe],
  exports: [MTreeDirectoryComponent, MFilterTreeNodesPipe],
  imports: [CommonModule, NzTreeModule, NzEmptyModule, MWidgetsModule, NzIconModule]
})
export class MTreeDirectoryModule {}
